/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const account_role = sqliteTable("account_role", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  user_id: text("user_id"),
  role_id: text("role_id"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const activity_photo = sqliteTable(
  "activity_photo",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    activity_id: text("activity_id"),
    url: text("url"),
    caption: text("caption"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE activity_id = ? in gallery by activity */
    index("activity_photo_by_activity").on(table.activity_id),
  ],
);

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
  },
  (table) => [
    /** ORDER BY server_ts DESC in activity feed */
    index("activity_recent_by_feed").on(table.server_ts),
    /** WHERE entity_type = ? AND entity_id = ? in entity history */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
  ],
);

export const app_role = sqliteTable("app_role", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  name: text("name"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    user_id: text("user_id"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const attendance_entry = sqliteTable(
  "attendance_entry",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    session_id: text("session_id"),
    person_id: text("person_id"),
    person_name: text("person_name"),
    status: text("status"),
    checked_in_at: text("checked_in_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE session_id = ? in check-in roster */
    index("attendance_entry_by_session").on(table.session_id),
  ],
);

export const attendance_session = sqliteTable(
  "attendance_session",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    meeting_id: text("meeting_id"),
    occurrence_start: text("occurrence_start"),
    headcount: integer("headcount"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE meeting_id = ? AND occurrence_start = ? in session of an occurrence */
    index("attendance_session_by_meeting").on(table.meeting_id, table.occurrence_start),
  ],
);

export const capability = sqliteTable("capability", {
  id: text("id").primaryKey(),
  name: text("name"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const church = sqliteTable("church", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  parent_id: text("parent_id"),
  path: text("path"),
  name: text("name"),
  description: text("description"),
  history: text("history"),
  email: text("email"),
  phone: text("phone"),
  website: text("website"),
  address: text("address"),
  city: text("city"),
  country: text("country"),
  socials: text("socials"),
  status: text("status"),
  is_public: integer("is_public"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  timezone: text("timezone"),
  gamification_enabled: integer("gamification_enabled"),
});

export const church_group = sqliteTable("church_group", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  group_type_id: text("group_type_id"),
  name: text("name"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const church_relation = sqliteTable("church_relation", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  related_church_id: text("related_church_id"),
  kind: text("kind"),
  note: text("note"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const cleaning_assignment = sqliteTable(
  "cleaning_assignment",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    shift_id: text("shift_id"),
    person_id: text("person_id"),
    person_name: text("person_name"),
    area: text("area"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE shift_id = ? in shift assignments */
    index("cleaning_assignment_by_shift").on(table.shift_id),
  ],
);

export const cleaning_shift = sqliteTable(
  "cleaning_shift",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    venue_id: text("venue_id"),
    title: text("title"),
    shift_date: text("shift_date"),
    starts_at: text("starts_at"),
    ends_at: text("ends_at"),
    status: text("status"),
    done_on: text("done_on"),
    notes: text("notes"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE group_id = ? in cleaning group shifts */
    index("cleaning_shift_by_group").on(table.group_id),
  ],
);

export const devotional_followup = sqliteTable(
  "devotional_followup",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    progress_id: text("progress_id"),
    author_user_id: text("author_user_id"),
    moderator_user_id: text("moderator_user_id"),
    moderator_name: text("moderator_name"),
    comment: text("comment"),
    seen_at: text("seen_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE progress_id = ? in progress follow-up */
    index("devotional_followup_by_progress").on(table.progress_id),
  ],
);

export const devotional_item = sqliteTable(
  "devotional_item",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    plan_id: text("plan_id"),
    title: text("title"),
    content: text("content"),
    verses: text("verses"),
    target_date: text("target_date"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE plan_id = ? in plan items */
    index("devotional_item_by_plan").on(table.plan_id),
  ],
);

export const devotional_plan = sqliteTable("devotional_plan", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  group_id: text("group_id"),
  title: text("title"),
  description: text("description"),
  starts_on: text("starts_on"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const devotional_progress = sqliteTable(
  "devotional_progress",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    plan_id: text("plan_id"),
    item_id: text("item_id"),
    user_id: text("user_id"),
    user_name: text("user_name"),
    done: integer("done"),
    done_on: text("done_on"),
    reflection: text("reflection"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE item_id = ? in item progress (moderator panel) */
    index("devotional_progress_by_item").on(table.item_id),
  ],
);

export const effective_grant = sqliteTable("effective_grant", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  capability_id: text("capability_id"),
  node_kind: text("node_kind"),
  node_id: text("node_id"),
  church_id: text("church_id"),
  activity_scope: text("activity_scope"),
  can_read: integer("can_read"),
  can_write: integer("can_write"),
  can_manage: integer("can_manage"),
  compiled_at: text("compiled_at"),
});

export const finance_category = sqliteTable("finance_category", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  name: text("name"),
  kind: text("kind"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const finance_record = sqliteTable(
  "finance_record",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    kind: text("kind"),
    description: text("description"),
    amount_minor: integer("amount_minor"),
    currency: text("currency"),
    occurred_at: text("occurred_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    fund_id: text("fund_id"),
    category_id: text("category_id"),
    receipt_url: text("receipt_url"),
  },
  (table) => [
    /** Range reports: WHERE church_id = ? ORDER BY occurred_at */
    index("finance_record_by_church_date").on(table.church_id, table.occurred_at),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const fund = sqliteTable("fund", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  name: text("name"),
  description: text("description"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const group_category = sqliteTable("group_category", {
  id: text("id").primaryKey(),
  name: text("name"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const group_category_capability = sqliteTable("group_category_capability", {
  id: text("id").primaryKey(),
  category_id: text("category_id"),
  capability_id: text("capability_id"),
});

export const group_member = sqliteTable("group_member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  group_id: text("group_id"),
  person_id: text("person_id"),
  role: text("role"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  person_name: text("person_name"),
});

export const group_type = sqliteTable("group_type", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  category_id: text("category_id"),
  name: text("name"),
  description: text("description"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const inventory_item = sqliteTable(
  "inventory_item",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    venue_id: text("venue_id"),
    name: text("name"),
    kind: text("kind"),
    category: text("category"),
    quantity: integer("quantity"),
    min_quantity: integer("min_quantity"),
    condition: text("condition"),
    responsible_person_id: text("responsible_person_id"),
    responsible_name: text("responsible_name"),
    notes: text("notes"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Added by hand before 2026-09-28; the query it serves was not recorded. */
    index("inventory_item_by_church").on(table.church_id),
  ],
);

export const inventory_movement = sqliteTable(
  "inventory_movement",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    item_id: text("item_id"),
    kind: text("kind"),
    quantity: integer("quantity"),
    from_venue_id: text("from_venue_id"),
    to_venue_id: text("to_venue_id"),
    note: text("note"),
    occurred_at: text("occurred_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** Added by hand before 2026-09-28; the query it serves was not recorded. */
    index("inventory_movement_by_item").on(table.item_id),
  ],
);

export const meeting = sqliteTable(
  "meeting",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    venue_id: text("venue_id"),
    organizer_person_id: text("organizer_person_id"),
    organizer_name: text("organizer_name"),
    title: text("title"),
    description: text("description"),
    kind: text("kind"),
    is_public: integer("is_public"),
    starts_at: text("starts_at"),
    ends_at: text("ends_at"),
    timezone: text("timezone"),
    rrule: text("rrule"),
    location_detail: text("location_detail"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE church_id = ? / group_id = ? in listings and calendar */
    index("meeting_by_church").on(table.church_id),
    /** WHERE church_id = ? / group_id = ? in listings and calendar */
    index("meeting_by_group").on(table.group_id),
  ],
);

export const meeting_activity = sqliteTable(
  "meeting_activity",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    meeting_id: text("meeting_id"),
    occurrence_start: text("occurrence_start"),
    kind: text("kind"),
    title: text("title"),
    content: text("content"),
    song_id: text("song_id"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE meeting_id = ? in meeting details */
    index("meeting_activity_by_meeting").on(table.meeting_id),
  ],
);

export const meeting_exception = sqliteTable(
  "meeting_exception",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    meeting_id: text("meeting_id"),
    occurrence_start: text("occurrence_start"),
    kind: text("kind"),
    new_start: text("new_start"),
    new_end: text("new_end"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE meeting_id = ? when materializing occurrences */
    index("meeting_exception_by_meeting").on(table.meeting_id),
  ],
);

export const meeting_invite = sqliteTable(
  "meeting_invite",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    meeting_id: text("meeting_id"),
    person_id: text("person_id"),
    person_name: text("person_name"),
    status: text("status"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE meeting_id = ? in guest list */
    index("meeting_invite_by_meeting").on(table.meeting_id),
  ],
);

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

export const membership = sqliteTable("membership", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  person_id: text("person_id"),
  status: text("status"),
  baptized: integer("baptized"),
  baptized_at: text("baptized_at"),
  serves: integer("serves"),
  serve_group_id: text("serve_group_id"),
  is_leader: integer("is_leader"),
  is_pastor: integer("is_pastor"),
  joined_at: text("joined_at"),
  notes: text("notes"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const permission_grant = sqliteTable("permission_grant", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  subject_kind: text("subject_kind"),
  subject_id: text("subject_id"),
  scope_kind: text("scope_kind"),
  scope_id: text("scope_id"),
  capability_id: text("capability_id"),
  action: text("action"),
  effect: text("effect"),
  inherit: integer("inherit"),
  created_by: text("created_by"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const person = sqliteTable("person", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  account_user_id: text("account_user_id"),
  name: text("name"),
  email: text("email"),
  phone: text("phone"),
  photo: text("photo"),
  address: text("address"),
  birthdate: text("birthdate"),
  notes: text("notes"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const person_relation = sqliteTable("person_relation", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  person_id: text("person_id"),
  related_person_id: text("related_person_id"),
  kind: text("kind"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const prayer_request = sqliteTable(
  "prayer_request",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    activity_id: text("activity_id"),
    requester_user_id: text("requester_user_id"),
    requester_name: text("requester_name"),
    content: text("content"),
    is_private: integer("is_private"),
    status: text("status"),
    answered_at: text("answered_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE activity_id = ? in activity prayer requests */
    index("prayer_request_by_activity").on(table.activity_id),
  ],
);

export const projection_item = sqliteTable("projection_item", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  venue_id: text("venue_id"),
  kind: text("kind"),
  title: text("title"),
  content: text("content"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  notes: text("notes"),
});

export const rehearsal = sqliteTable(
  "rehearsal",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    title: text("title"),
    starts_at: text("starts_at"),
    ends_at: text("ends_at"),
    location: text("location"),
    notes: text("notes"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE group_id = ? in group schedule */
    index("rehearsal_by_group").on(table.group_id),
  ],
);

export const scene_element = sqliteTable(
  "scene_element",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    work_id: text("work_id"),
    kind: text("kind"),
    name: text("name"),
    description: text("description"),
    quantity: integer("quantity"),
    assigned_person_id: text("assigned_person_id"),
    assigned_name: text("assigned_name"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE work_id = ? in elements linked to a work */
    index("scene_element_by_work").on(table.work_id),
  ],
);

export const scene_photo = sqliteTable(
  "scene_photo",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    work_id: text("work_id"),
    url: text("url"),
    caption: text("caption"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE work_id = ? in work gallery */
    index("scene_photo_by_work").on(table.work_id),
  ],
);

export const scene_work = sqliteTable(
  "scene_work",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    kind: text("kind"),
    title: text("title"),
    content: text("content"),
    song_id: text("song_id"),
    music_url: text("music_url"),
    notes: text("notes"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE group_id = ? in group works */
    index("scene_work_by_group").on(table.group_id),
  ],
);

export const schedule_block = sqliteTable(
  "schedule_block",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    meeting_id: text("meeting_id"),
    occurrence_start: text("occurrence_start"),
    kind: text("kind"),
    title: text("title"),
    duration_minutes: integer("duration_minutes"),
    responsible_person_id: text("responsible_person_id"),
    responsible_name: text("responsible_name"),
    notes: text("notes"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE meeting_id = ? in meeting schedule */
    index("schedule_block_by_meeting").on(table.meeting_id),
  ],
);

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

export const setlist = sqliteTable(
  "setlist",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    title: text("title"),
    meeting_id: text("meeting_id"),
    rehearsal_id: text("rehearsal_id"),
    notes: text("notes"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE group_id = ? in group library */
    index("setlist_by_group").on(table.group_id),
  ],
);

export const setlist_song = sqliteTable(
  "setlist_song",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    setlist_id: text("setlist_id"),
    song_id: text("song_id"),
    sort_order: integer("sort_order"),
    key_override: text("key_override"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE setlist_id = ? in setlist details */
    index("setlist_song_by_setlist").on(table.setlist_id),
  ],
);

export const song = sqliteTable(
  "song",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    title: text("title"),
    author: text("author"),
    song_key: text("song_key"),
    tempo: integer("tempo"),
    tags: text("tags"),
    lyrics: text("lyrics"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE group_id = ? in group library */
    index("song_by_group").on(table.group_id),
  ],
);

export const song_part = sqliteTable(
  "song_part",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    group_id: text("group_id"),
    song_id: text("song_id"),
    instrument: text("instrument"),
    content: text("content"),
    person_id: text("person_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE song_id = ? in chord editor by role */
    index("song_part_by_song").on(table.song_id),
  ],
);

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  gamification_opt_in: integer("gamification_opt_in"),
});

export const venue = sqliteTable("venue", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  church_id: text("church_id"),
  name: text("name"),
  description: text("description"),
  address: text("address"),
  capacity: integer("capacity"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  lat: real("lat"),
  lng: real("lng"),
  purposes: text("purposes"),
  opening_hours: text("opening_hours"),
});

export const venue_image = sqliteTable(
  "venue_image",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    church_id: text("church_id"),
    venue_id: text("venue_id"),
    url: text("url"),
    caption: text("caption"),
    sort_order: integer("sort_order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE venue_id = ? in venue gallery */
    index("venue_image_by_venue").on(table.venue_id),
  ],
);

export const drizzleSchema = {
  account_role,
  activity_photo,
  activity_recent,
  app_role,
  attachment,
  attendance_entry,
  attendance_session,
  capability,
  church,
  church_group,
  church_relation,
  cleaning_assignment,
  cleaning_shift,
  devotional_followup,
  devotional_item,
  devotional_plan,
  devotional_progress,
  effective_grant,
  finance_category,
  finance_record,
  font_family,
  font_variant,
  fund,
  group_category,
  group_category_capability,
  group_member,
  group_type,
  inventory_item,
  inventory_movement,
  meeting,
  meeting_activity,
  meeting_exception,
  meeting_invite,
  member,
  membership,
  organization,
  permission_grant,
  person,
  person_relation,
  prayer_request,
  projection_item,
  rehearsal,
  scene_element,
  scene_photo,
  scene_work,
  schedule_block,
  session,
  setlist,
  setlist_song,
  song,
  song_part,
  themes,
  user,
  venue,
  venue_image,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = ["attachment"] as const;

export type AccountRole = InferSelectModel<typeof account_role>;
export type AccountRoleInsert = InferInsertModel<typeof account_role>;
export type AccountRoleRecord = AccountRole;
export type ActivityPhoto = InferSelectModel<typeof activity_photo>;
export type ActivityPhotoInsert = InferInsertModel<typeof activity_photo>;
export type ActivityPhotoRecord = ActivityPhoto;
export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type AppRole = InferSelectModel<typeof app_role>;
export type AppRoleInsert = InferInsertModel<typeof app_role>;
export type AppRoleRecord = AppRole;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type AttendanceEntry = InferSelectModel<typeof attendance_entry>;
export type AttendanceEntryInsert = InferInsertModel<typeof attendance_entry>;
export type AttendanceEntryRecord = AttendanceEntry;
export type AttendanceSession = InferSelectModel<typeof attendance_session>;
export type AttendanceSessionInsert = InferInsertModel<typeof attendance_session>;
export type AttendanceSessionRecord = AttendanceSession;
export type Capability = InferSelectModel<typeof capability>;
export type CapabilityInsert = InferInsertModel<typeof capability>;
export type CapabilityRecord = Capability;
export type Church = InferSelectModel<typeof church>;
export type ChurchInsert = InferInsertModel<typeof church>;
export type ChurchRecord = Church;
export type ChurchGroup = InferSelectModel<typeof church_group>;
export type ChurchGroupInsert = InferInsertModel<typeof church_group>;
export type ChurchGroupRecord = ChurchGroup;
export type ChurchRelation = InferSelectModel<typeof church_relation>;
export type ChurchRelationInsert = InferInsertModel<typeof church_relation>;
export type ChurchRelationRecord = ChurchRelation;
export type CleaningAssignment = InferSelectModel<typeof cleaning_assignment>;
export type CleaningAssignmentInsert = InferInsertModel<typeof cleaning_assignment>;
export type CleaningAssignmentRecord = CleaningAssignment;
export type CleaningShift = InferSelectModel<typeof cleaning_shift>;
export type CleaningShiftInsert = InferInsertModel<typeof cleaning_shift>;
export type CleaningShiftRecord = CleaningShift;
export type DevotionalFollowup = InferSelectModel<typeof devotional_followup>;
export type DevotionalFollowupInsert = InferInsertModel<typeof devotional_followup>;
export type DevotionalFollowupRecord = DevotionalFollowup;
export type DevotionalItem = InferSelectModel<typeof devotional_item>;
export type DevotionalItemInsert = InferInsertModel<typeof devotional_item>;
export type DevotionalItemRecord = DevotionalItem;
export type DevotionalPlan = InferSelectModel<typeof devotional_plan>;
export type DevotionalPlanInsert = InferInsertModel<typeof devotional_plan>;
export type DevotionalPlanRecord = DevotionalPlan;
export type DevotionalProgress = InferSelectModel<typeof devotional_progress>;
export type DevotionalProgressInsert = InferInsertModel<typeof devotional_progress>;
export type DevotionalProgressRecord = DevotionalProgress;
export type EffectiveGrant = InferSelectModel<typeof effective_grant>;
export type EffectiveGrantInsert = InferInsertModel<typeof effective_grant>;
export type EffectiveGrantRecord = EffectiveGrant;
export type FinanceCategory = InferSelectModel<typeof finance_category>;
export type FinanceCategoryInsert = InferInsertModel<typeof finance_category>;
export type FinanceCategoryRecord = FinanceCategory;
export type FinanceRecord = InferSelectModel<typeof finance_record>;
export type FinanceRecordInsert = InferInsertModel<typeof finance_record>;
export type FinanceRecordRecord = FinanceRecord;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Fund = InferSelectModel<typeof fund>;
export type FundInsert = InferInsertModel<typeof fund>;
export type FundRecord = Fund;
export type GroupCategory = InferSelectModel<typeof group_category>;
export type GroupCategoryInsert = InferInsertModel<typeof group_category>;
export type GroupCategoryRecord = GroupCategory;
export type GroupCategoryCapability = InferSelectModel<typeof group_category_capability>;
export type GroupCategoryCapabilityInsert = InferInsertModel<typeof group_category_capability>;
export type GroupCategoryCapabilityRecord = GroupCategoryCapability;
export type GroupMember = InferSelectModel<typeof group_member>;
export type GroupMemberInsert = InferInsertModel<typeof group_member>;
export type GroupMemberRecord = GroupMember;
export type GroupType = InferSelectModel<typeof group_type>;
export type GroupTypeInsert = InferInsertModel<typeof group_type>;
export type GroupTypeRecord = GroupType;
export type InventoryItem = InferSelectModel<typeof inventory_item>;
export type InventoryItemInsert = InferInsertModel<typeof inventory_item>;
export type InventoryItemRecord = InventoryItem;
export type InventoryMovement = InferSelectModel<typeof inventory_movement>;
export type InventoryMovementInsert = InferInsertModel<typeof inventory_movement>;
export type InventoryMovementRecord = InventoryMovement;
export type Meeting = InferSelectModel<typeof meeting>;
export type MeetingInsert = InferInsertModel<typeof meeting>;
export type MeetingRecord = Meeting;
export type MeetingActivity = InferSelectModel<typeof meeting_activity>;
export type MeetingActivityInsert = InferInsertModel<typeof meeting_activity>;
export type MeetingActivityRecord = MeetingActivity;
export type MeetingException = InferSelectModel<typeof meeting_exception>;
export type MeetingExceptionInsert = InferInsertModel<typeof meeting_exception>;
export type MeetingExceptionRecord = MeetingException;
export type MeetingInvite = InferSelectModel<typeof meeting_invite>;
export type MeetingInviteInsert = InferInsertModel<typeof meeting_invite>;
export type MeetingInviteRecord = MeetingInvite;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Membership = InferSelectModel<typeof membership>;
export type MembershipInsert = InferInsertModel<typeof membership>;
export type MembershipRecord = Membership;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type PermissionGrant = InferSelectModel<typeof permission_grant>;
export type PermissionGrantInsert = InferInsertModel<typeof permission_grant>;
export type PermissionGrantRecord = PermissionGrant;
export type Person = InferSelectModel<typeof person>;
export type PersonInsert = InferInsertModel<typeof person>;
export type PersonRecord = Person;
export type PersonRelation = InferSelectModel<typeof person_relation>;
export type PersonRelationInsert = InferInsertModel<typeof person_relation>;
export type PersonRelationRecord = PersonRelation;
export type PrayerRequest = InferSelectModel<typeof prayer_request>;
export type PrayerRequestInsert = InferInsertModel<typeof prayer_request>;
export type PrayerRequestRecord = PrayerRequest;
export type ProjectionItem = InferSelectModel<typeof projection_item>;
export type ProjectionItemInsert = InferInsertModel<typeof projection_item>;
export type ProjectionItemRecord = ProjectionItem;
export type Rehearsal = InferSelectModel<typeof rehearsal>;
export type RehearsalInsert = InferInsertModel<typeof rehearsal>;
export type RehearsalRecord = Rehearsal;
export type SceneElement = InferSelectModel<typeof scene_element>;
export type SceneElementInsert = InferInsertModel<typeof scene_element>;
export type SceneElementRecord = SceneElement;
export type ScenePhoto = InferSelectModel<typeof scene_photo>;
export type ScenePhotoInsert = InferInsertModel<typeof scene_photo>;
export type ScenePhotoRecord = ScenePhoto;
export type SceneWork = InferSelectModel<typeof scene_work>;
export type SceneWorkInsert = InferInsertModel<typeof scene_work>;
export type SceneWorkRecord = SceneWork;
export type ScheduleBlock = InferSelectModel<typeof schedule_block>;
export type ScheduleBlockInsert = InferInsertModel<typeof schedule_block>;
export type ScheduleBlockRecord = ScheduleBlock;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Setlist = InferSelectModel<typeof setlist>;
export type SetlistInsert = InferInsertModel<typeof setlist>;
export type SetlistRecord = Setlist;
export type SetlistSong = InferSelectModel<typeof setlist_song>;
export type SetlistSongInsert = InferInsertModel<typeof setlist_song>;
export type SetlistSongRecord = SetlistSong;
export type Song = InferSelectModel<typeof song>;
export type SongInsert = InferInsertModel<typeof song>;
export type SongRecord = Song;
export type SongPart = InferSelectModel<typeof song_part>;
export type SongPartInsert = InferInsertModel<typeof song_part>;
export type SongPartRecord = SongPart;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type Venue = InferSelectModel<typeof venue>;
export type VenueInsert = InferInsertModel<typeof venue>;
export type VenueRecord = Venue;
export type VenueImage = InferSelectModel<typeof venue_image>;
export type VenueImageInsert = InferInsertModel<typeof venue_image>;
export type VenueImageRecord = VenueImage;
